import { render, staticRenderFns } from "./FlashFixParcel.vue?vue&type=template&id=62f0f4f7"
import script from "./FlashFixParcel.vue?vue&type=script&lang=js"
export * from "./FlashFixParcel.vue?vue&type=script&lang=js"
import style0 from "./FlashFixParcel.vue?vue&type=style&index=0&id=62f0f4f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports